import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SiaPwaApi } from '../apis/sia-pwa.api';

@Injectable({
  providedIn: 'root',
})
export class SiaPwaService {
  private pwaApi = inject(SiaPwaApi);

  private _toUpdate: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  );

  private _clientVersion: BehaviorSubject<string> = new BehaviorSubject<string>(
    '0.0.0',
  );

  private _serverVersion: BehaviorSubject<string> = new BehaviorSubject<string>(
    '0.0.0',
  );

  private _install: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  get toUpdate$() {
    return this._toUpdate.asObservable();
  }

  get clientVersion$() {
    return this._clientVersion.asObservable();
  }

  get serverVersion$() {
    return this._serverVersion.asObservable();
  }

  get install$() {
    return this._install.asObservable();
  }

  toUpdate(newValue: boolean) {
    this._toUpdate.next(newValue);
  }

  notifyClientVersion(version: string) {
    this._clientVersion.next(version);
  }

  notifyServerVersion(version: string) {
    this._serverVersion.next(version);
  }

  getServerVersion() {
    return this.pwaApi.getServerVersion();
  }

  promptInstall(e: any) {
    this._install.next(e);
  }
}
